module.exports = __webpack_public_path__ + "img/VT.34d3a6c9.webp";